import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../security/login.service';
import { FaviconService } from '../favicon.service';
import { WpBookingRequest } from '../wp-booking-request';
import { School } from '../school';
import * as moment from 'moment';
import { SalesAgent } from '../sales-agent';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ToastMessageService } from '../toast-message.service';
import { ContactRequest } from '../contact-request';
import { WpBookingRequestComment } from '../wp-booking-request-comment';
import { UserService } from '../service/user.service';
import { BookingRequestToApprove } from '../booking-request-to-approve';
import { Country } from '../country';
import { ProgrammeType } from '../programme-type';
import { AccommodationType } from '../accommodation-type';
import { RoomType } from '../room-type';
import { BoardType } from '../board-type';
import { SchoolListItem } from '../school-list-item';
import { Language } from '../language';
import { LanguageCourse } from '../language-course';
import { LastValueFromConfig } from 'rxjs/internal/lastValueFrom';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as Editor from '../../libs/ckeditor';
import { GmailMessage } from '../gmail-message';
import { ApiError } from '../api-error';
import { EmailSignatureService } from '../service/email-signature.service';
import { GmailMessageWithOption } from '../gmail-message-with-option';
import { EmailHistory } from '../email-history';

@Component({
  selector: 'app-wp-booking-request-edit',
  templateUrl: './wp-booking-request-edit.component.html',
  styleUrls: ['./wp-booking-request-edit.component.css']
})
export class WpBookingRequestEditComponent implements OnInit {

  selectedBookingRequest: WpBookingRequest | null = null;
  schoolList: SchoolListItem[] = [];
  requestId: number;
  languageList: Language[] = [];
  agentList: SalesAgent[] = [];
  requestData: WpBookingRequest[] = [];
  suggestedSchools: School[] = [];

  contactRequests: SelectItem[] = [];
  accommodationTypes: AccommodationType[] = [];
  roomTypes: RoomType[] = [];
  boardTypes: BoardType[] = [];
  displayRequests = false;
  selectedContactRequest: ContactRequest | null = null;
  newCommentBody = null;
  bookingRequestComments: WpBookingRequestComment[] = [];
  editComment = false;
  newCommentStr: string | null = null;
  selectedComment: WpBookingRequestComment| null = null;

  showDestinationDialog = false;
  showProgrammeTypeDialog = false;
  showAccommodationTypeDialog = false;
  showRoomTypeDialog = false;
  showBoardTypeDialog = false;

  schoolWithDetail: School | null = null;
  requestToApprove: BookingRequestToApprove | null = null;

  newAccommodationType: AccommodationType | null = null;
  newRoomType: RoomType | null = null;
  newBoardType: BoardType | null = null;

  languageCourseList: LanguageCourse[] = [];
  isEmailDialogActive = false;
  emailForm: FormGroup | null = null;
  public Editor = Editor;
  sentEmails: EmailHistory[] = [];
  selectedEmailHistory: EmailHistory | null = null;
  displayMailHistoryDetail = false;
  isSendingEmail = false;

  constructor(
    private httpService: HttpService,
    private route: ActivatedRoute,
    private loginService: LoginService,
    private favicon: FaviconService,
    private router: Router,
    private toastService: ToastMessageService,
    private confirmationService: ConfirmationService,
    public userService: UserService, 
    private builder: FormBuilder,
    public emailSignatureService: EmailSignatureService
  ) {
    this.loginService.activatedNavigationComponent = true;
    this.favicon.sbms();
    this.requestId = parseInt(this.route.snapshot.paramMap.get("requestId")!);
  }

  ngOnInit(): void {
    this.httpService.getWpBookingRequestById(this.requestId).subscribe(request => {
      this.selectedBookingRequest = request;
      this.requestData.push(this.selectedBookingRequest);
      this.loadLanguageCourseList(this.selectedBookingRequest.lviSchool!);
      this.initEmailForm();
      this.initEmailHistory();

      this.httpService.getAvailableContactRequestsToLink().subscribe(reqs => {
        this.contactRequests = [];
        for (let req of reqs) {
          if (this.selectedBookingRequest!.contactRequestId && this.selectedBookingRequest!.contactRequestId == req.id) {
            this.selectedContactRequest = req;
          }
          this.contactRequests.push({
            label: req.id + " " + req.firstName + " " + req.lastName + " - " + moment(req.created).format("DD/MM/YYYY"),
            value: req
          });
        }
      });
      if (this.selectedBookingRequest.programme != null) {
        this.httpService.getSchoolsByProgrammeName(this.selectedBookingRequest.programme).subscribe(res => {
          this.suggestedSchools = res;
        });
      }
    });
    this.updateBookingRequestComments();
    this.httpService.getActiveSchools().subscribe(schools => {
      this.schoolList = schools;
    });
    this.httpService.getLanguages().subscribe(languages => {
      this.languageList = languages;
    });
    this.httpService.getSalesAgents().subscribe(agents => {
      this.agentList = agents;
    });
    this.httpService.getAccommodationTypes().subscribe(res => {
      this.accommodationTypes = res;
    });
    this.httpService.getRoomTypes().subscribe(res => {
      this.roomTypes = res;
    });
    this.httpService.getBoardTypes().subscribe(res => {
      this.boardTypes = res;
    });
  }

  initEmailForm(){
    this.emailForm = this.builder.group({
      body: [null, Validators.required],
      subject: [null, Validators.required],
      signature: this.emailSignatureService.emailSignatures[0],
      hasPastePixel: [false, Validators.required]
    });
  }
  
  initEmailHistory(){
    this.httpService.getBookingRequestEmailHistoryByRequestId(this.selectedBookingRequest!.id!).subscribe(res => {
      this.sentEmails = res;
      console.log(res);
    }, error => this.toastService.addApiError(new ApiError(error)));
  }

  loadLanguageCourseList(school: School){
    const bookingRequest = this.selectedBookingRequest;
    if(school){
      this.httpService.getLanguageCoursesBySchoolId(school.id!).subscribe(res => {
        this.languageCourseList = res;
        if(bookingRequest!.languageCourse){
          this.setSelectedLanguageCourse(this.languageCourseList, bookingRequest!.languageCourse!.id!);
        }
      });
    }
  }

  setSelectedLanguageCourse(courseList: LanguageCourse[], courseId: number){
    for(let course of courseList){
      if(course.id == courseId){
        this.selectedBookingRequest!.languageCourse = course;
      }
    }
  }

  testAccommodationType() {
    //if no value, accommodation type will be set 'none'
    if (this.requestToApprove!.accommodationType == null || this.requestToApprove!.accommodationType == "") {
      return true;
    }
    //if accommodation is correctly found. just use it
    for (let accommodationType of this.accommodationTypes) {
      if (this.requestToApprove!.accommodationType == accommodationType.name) {
        return true;
      }
    }
    return false;
  }

  testRoomType() {
    if (this.requestToApprove!.roomType == null || this.requestToApprove!.roomType == "") {
      return true;
    }
    for (let roomType of this.roomTypes) {
      if (this.requestToApprove!.roomType == roomType.name) {
        return true;
      }
    }
    return false;
  }

  testBoardType() {
    if (this.requestToApprove!.board == null || this.requestToApprove!.board == "") {
      return true;
    }
    for (let boardType of this.boardTypes) {
      if (this.requestToApprove!.board == boardType.name) {
        return true;
      }
    }
    return false;
  }

  updateBookingRequestComments() {
    this.httpService.getWpBookingRequestCommentsByRequestId(this.requestId!).subscribe(res => {
      for(let comment of res){
        comment.created = moment(comment.created);
      }
      this.bookingRequestComments = res;
    });
  }

  goToPrintPage() {
    window.open("management/wp-booking-request-print/" + this.requestId, "_blank");
  }

  parseStudentLanguage() {
    let languageStr = this.selectedBookingRequest!.firstLanguage.toLowerCase();
    if (languageStr == "français") {
      return this.languageList[0];
    }
    if (languageStr == "nederlands") {
      return this.languageList[2];
    }
    if (languageStr == "español") {
      return this.languageList[3];
    }
    else {
      return this.languageList[1];
    }
  }

  updateRequest() {
    if (this.selectedContactRequest) {
      this.selectedBookingRequest!.contactRequestId = this.selectedContactRequest.id!;
    }
    this.httpService.putWpBookingRequest(this.selectedBookingRequest!).subscribe(() => {
      this.toastService.addSuccess("Success👍", "Booking request updated");
    }, error => this.toastService.addError("Error", error.message));
  }

  deleteRequest() {
    this.confirmationService.confirm({
      message: "Are you sure that you want to delete this request?",
      accept: () => {
        this.httpService.deleteWpBookingRequest(this.selectedBookingRequest!.id!).subscribe(() => {
          this.toastService.addSuccess("Success", "Booking request deleted");
          this.router.navigateByUrl("/management/wp-booking-requests");
        }, error => this.toastService.addError("Error", error.message));
      }
    });
  }

  //Approval flow: approveBookingRequest -> choose destination -> choose programme type -> check accommodation type -> check room type -> check board type -> confirm request
  approveBookingRequest() {
    let contactRequestName = null;
    let bookingRequest = this.selectedBookingRequest!;
    if (bookingRequest.contactRequestId) {
      for (let contactRequest of this.contactRequests) {
        if (contactRequest.value.id == this.selectedBookingRequest!.contactRequestId) {
          contactRequestName = contactRequest.value.firstName + " " + contactRequest.value.familyName + " (ID:" + contactRequest.value.id + ")";
        }
      }
    }
    if(!bookingRequest.languageCourse){
      this.toastService.addError("Error", "Course is required");
      return;
    }
    this.requestToApprove = new BookingRequestToApprove(
      bookingRequest.firstName,
      bookingRequest.familyName,
      bookingRequest.age,
      bookingRequest.nationality,
      bookingRequest.firstLanguage,
      bookingRequest.phoneNumber,
      bookingRequest.email,
      bookingRequest.city,
      bookingRequest.country,
      bookingRequest.otherCountry,
      bookingRequest.programme,
      bookingRequest.lessonsPerWeek,
      bookingRequest.programmeOption,
      bookingRequest.startDay,
      bookingRequest.endDay,
      bookingRequest.otherNationality,
      bookingRequest.accommodationType,
      bookingRequest.roomType,
      bookingRequest.board,
      bookingRequest.nonSmokingFamily,
      bookingRequest.familyWithNoKids,
      bookingRequest.familyWithNoPets,
      bookingRequest.allergyOrMedicalIssues,
      bookingRequest.accommodationPreference,
      bookingRequest.mobileNumber,
      bookingRequest.gender,
      bookingRequest.birthPlace,
      bookingRequest.birthDate,
      bookingRequest.targetLanguageLevel,
      bookingRequest.learningDifficulty,
      bookingRequest.street,
      bookingRequest.additionalAddress,
      bookingRequest.emergencyContactName,
      bookingRequest.emergencyContactType,
      bookingRequest.emergencyContactEmail,
      bookingRequest.emergencyContactPhone,
      bookingRequest.parentName,
      bookingRequest.parentProfession,
      bookingRequest.parentEmail,
      bookingRequest.parentPhone,
      bookingRequest.travelWithLvi,
      bookingRequest.airportTransferType,
      bookingRequest.needCancellationGuarantee,
      bookingRequest.needMedicalInsurance,
      bookingRequest.promotionCode,
      bookingRequest.informationSource,
      bookingRequest.comment,
      bookingRequest.created,
      bookingRequest.isApproved,
      bookingRequest.language,
      bookingRequest.hobbies,
      bookingRequest.billingCurrency,
      bookingRequest.billingContact,
      bookingRequest.paymentMethod,
      bookingRequest.billingPersonName,
      bookingRequest.billingPersonPhone,
      bookingRequest.billingPersonEmail,
      bookingRequest.billingPersonStreet,
      bookingRequest.billingPersonExtraAddress,
      bookingRequest.billingPersonCity,
      bookingRequest.billingPersonCountry,
      bookingRequest.billingPersonPostalCode,
      bookingRequest.billingPersonOtherCountry,
      bookingRequest.postalCode,
      bookingRequest.school,
      bookingRequest.languageTeacher,
      bookingRequest.schoolAddress,
      bookingRequest.siblingsAge,
      bookingRequest.lastModified,
      bookingRequest.lastModifiedBy,
      false,
      bookingRequest.languageCourse,
      null,
      null,
      bookingRequest.id,
      bookingRequest.agent,
      bookingRequest.lviSchool!,
      bookingRequest.contactRequestId,
      bookingRequest.duration
    );
    this.testRequestToApprove();
  }

  testRequestToApprove() {
    let bookingRequest = this.selectedBookingRequest!;
    if (!bookingRequest.agent) {
      this.toastService.addError("Error", "Agent is missing.");
      return;
    }
    if (!this.testAccommodationType()) {
      this.showAccommodationTypeDialog = true;
      return;
    }
    if (!this.testRoomType()) {
      this.showRoomTypeDialog = true;
      return;
    }
    if (!this.testBoardType()) {
      this.showBoardTypeDialog = true;
      return;
    }
    if (bookingRequest.lviSchool) {
      this.httpService.getSchoolById(bookingRequest.lviSchool!.id!).subscribe(res => {
        this.schoolWithDetail = res;
        if (this.schoolWithDetail.countryList.length == 1) {
          this.requestToApprove!.destination = this.schoolWithDetail.countryList[0];
        } else if (this.schoolWithDetail.countryList.length > 1) {
          this.showDestinationDialog = true;
          return;
        }
        if (this.schoolWithDetail.programmeTypes.length == 1) {
          this.requestToApprove!.programmeType = this.schoolWithDetail.programmeTypes[0];
        } else if (this.schoolWithDetail.programmeTypes.length > 1) {
          this.showProgrammeTypeDialog = true;
          return;
        }
        this.confirmBookingRequest();
      });
    } else {
      this.toastService.addError("Error", "School is missing.");
    }
  }

  updateAccommodationType() {
    this.requestToApprove!.accommodationType = this.newAccommodationType!.name;
    this.showAccommodationTypeDialog = false;
    this.testRequestToApprove();
  }

  updateRoomType() {
    this.requestToApprove!.roomType = this.newRoomType!.name;
    this.showRoomTypeDialog = false;
    this.testRequestToApprove();
  }
  updateBoardType() {
    this.requestToApprove!.board = this.newBoardType!.name;
    this.showBoardTypeDialog = false;
    this.testRequestToApprove();
  }

  confirmBookingRequest() {
    let contactRequestName = "No lead is attached to this booking";
    if (this.selectedContactRequest) {
      contactRequestName = this.selectedContactRequest.firstName + " " + this.selectedContactRequest.lastName + " (ID:" + this.selectedContactRequest.id + ")";
    }
    let destinationName = this.requestToApprove!.destination == null ? null : this.requestToApprove!.destination.name;
    let programmeTypeName = this.requestToApprove!.programmeType == null ? null : this.requestToApprove!.programmeType.name;

    this.confirmationService.confirm({
      message: "Do you want to create a new booking with the following parameters? \n" +
        "student: " + this.requestToApprove!.firstName + " " + this.requestToApprove!.familyName + "\n" +
        "school: " + this.schoolWithDetail!.name +
        "\ndestination: " + destinationName +
        "\nprogramme type: " + programmeTypeName +
        "\nagent: " + this.requestToApprove!.agent!.name +
        "\nlead: " + contactRequestName,
      accept: () => {
        this.httpService.approveWpBookingRequest(this.requestToApprove!).subscribe(booking => {
          this.router.navigateByUrl("/management/edit-booking/" + booking.id);
        }, error => this.toastService.addError("Error", error.message));
      }
    });
  }

  selectDestination(country: Country) {
    this.requestToApprove!.destination = country;
    this.showDestinationDialog = false;
    if (this.schoolWithDetail!.programmeTypes.length == 1) {
      this.requestToApprove!.programmeType = this.schoolWithDetail!.programmeTypes[0];
    } else if (this.schoolWithDetail!.programmeTypes.length > 1) {
      this.showProgrammeTypeDialog = true;
      return;
    }
    this.confirmBookingRequest();
  }

  selectProgrammeType(programmeType: ProgrammeType) {
    this.requestToApprove!.programmeType = programmeType;
    this.showProgrammeTypeDialog = false;
    this.confirmBookingRequest();
  }

  activateLeadSelector() {
    this.displayRequests = true;
  }

  selectLead() {
    this.displayRequests = false;
    this.selectedBookingRequest!.contactRequestId = this.selectedContactRequest!.id!;
    this.updateRequest();
  }

  postNewComment() {
    if (this.newCommentBody == "" || this.newCommentBody == null) {
      return;
    }
    this.httpService.postWpBookingRequestComment(new WpBookingRequestComment(this.newCommentBody), this.selectedBookingRequest!.id!).subscribe(() => {
      this.toastService.addSuccess("Success", "Comment posted");
      this.updateBookingRequestComments();
      this.newCommentBody = null;
    }, error => this.toastService.addError("Error", error.message));
  }

  activateCommentEditDialog(comment: WpBookingRequestComment) {
    this.selectedComment = comment;
    this.newCommentStr = comment.body;
    this.editComment = true;
  }

  updateComment() {
    this.editComment = false;
    this.selectedComment!.body = this.newCommentStr;
    this.httpService.putWpBookingRequestComment(this.selectedComment!).subscribe(() => {
      this.toastService.addSuccess("Success", "Comment updated");
      this.selectedComment = null;
      this.newCommentStr = null;
    }, error => this.toastService.addError("Error", error.message));
  }

  deleteComment(comment: any) {
    this.confirmationService.confirm({
      message: "Do you want to delete this comment?",
      accept: () => {
        this.httpService.deleteWpBookingRequestComment(comment.id).subscribe(() => {
          this.toastService.addSuccess("Success", "Comment deleted");
          this.updateBookingRequestComments();
        }, error => {
          this.toastService.addError("Error", error.message);
        });
      }
    });
  }

  setSelectedSchoolById(schoolId: number) {
    for (let schoolListItem of this.schoolList) {
      if (schoolListItem.id == schoolId) {
        const school = this.asSchool(schoolListItem);
        this.selectedBookingRequest!.lviSchool = school;
        this.loadLanguageCourseList(school);
        if(this.selectedBookingRequest!.lviSchool.id != school.id){
          this.selectedBookingRequest!.languageCourse = null;
        }
      }
    }
  }

  asSchool(listItem: SchoolListItem) {
    return new School(
      listItem.name,
      null,
      false,
      [],
      [],
      [],
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [],
      listItem.publicName,
      listItem.id
    );
  }

  openEmailDialog(){
    if(this.selectedBookingRequest?.email){
      this.isEmailDialogActive = true;
    } else {
      this.toastService.addError("Error", "This Booking Request has no email address");
    }
  }

  sendEmail(){
    if(this.selectedBookingRequest?.email){
      this.isSendingEmail = true;
      let message = new GmailMessageWithOption([this.selectedBookingRequest!.email], this.emailForm?.value.subject, this.emailForm?.value.body, this.emailForm?.value.hasPastePixel);
      this.httpService.sendEmailToBookingRequest(message, this.selectedBookingRequest!.id!, this.emailForm?.value.signature.id).subscribe(res => {
        this.toastService.addSuccess("Success", "Email sent");
        this.isEmailDialogActive = false;
        this.isSendingEmail = false;
      }, error => {
        this.toastService.addApiError(new ApiError(error));
        this.isSendingEmail = false;
      });
    }
  }

  activateEmailHistoryDetail(email: EmailHistory){
    this.selectedEmailHistory = email;
    this.displayMailHistoryDetail = true;
  }
}
